import { ResidentAppError } from '../../common/error'
import { ResidentAppErrorCode } from '../../common/types'

export const throwOnMovedOutWriteAccessDenied = (error: unknown): boolean =>
  error instanceof ResidentAppError &&
  error.errorCode === ResidentAppErrorCode.MOVED_OUT_WRITE_ACCESS_DENIED
